import React, {useMemo} from 'react';
import styled from "styled-components";
import VenatusAd from "../../ad/VenatusAd";
import SllTierRunAward from "./SllTierRunAward";
import SllTierRunInfo from "./SllTierRunInfo";
import useSllTierRun from "../../../common/hooks/sli/useSllTierRun";

const Wrapper = styled.div`
  width: 100%;
`;

const MainContent = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

const SllTierRunContent = () => {
    const {data, query} = useSllTierRun();
    const awardData = useMemo(() => {
        try {
            const obj = data.tier.award_result;
            return {
                exclude: obj.hard_carry,
                badLuck: obj.bad_luck,
                hidden: obj.hidden
            }
        } catch (e) {
           return {
               exclude: [],
               badLuck:[],
               hideen:[],
           }
        }
    },[data]);



    return (
        <Wrapper>
            <TierRunOverview/>
            <MainContent>
                <SllTierRunAward awardData={awardData}/>
                <SllTierRunInfo data={data.tier.section_result} scoreData={data.tier.score_result}/>
            </MainContent>
        </Wrapper>
    );
};


const TierRunOverviewWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: ${props => props.theme.color.site_main_color};
  border: 1px solid ${props => props.theme.color.default_border_color};
  border-radius: 6px;
  height: 230px;
`;

const TierRunOverviewContent = styled.div`
  padding: 16px 14px 12px 16px;
`;

const Title = styled.div`
  font-family: Pretendard;
  font-weight: 600;
  font-size: 24px;
  line-height: 100%;
  color: ${props => props.theme.color.dark_100};
`;
const SubTitle = styled.div`
  font-family: Pretendard;
  font-weight: 500;
  font-size: 16px;
  line-height: 130%;
  color: ${props => props.theme.color.dark_200};
  white-space: pre-wrap;
  margin-top: 6px;
  margin-bottom: 16px;
`;
const VideoWrapper = styled.div`
  width: 410px;
  height: 230px;
  background-color: #D9D9D9;
`;

const TierRunOverview = () => {
    return (
        <TierRunOverviewWrapper>
            <TierRunOverviewContent>
                <Title>
                    2026 SOOP X DEEPLOL 티어런
                </Title>
                <SubTitle>
                    SOOP과 딥롤이 함께 준비한 2026년 티어런 이벤트 협업을 통해 {'\n'}
                    더욱 볼거리가 풍부해진 티어 경쟁 콘텐츠를 선보입니다.
                </SubTitle>
                <div>
                    <img src={'images/sll/img_sll_tier_run_banner.png'} width={640} height={96}/>
                </div>
            </TierRunOverviewContent>
            <VideoWrapper>
                <VenatusAd placementName={'video'}/>
            </VideoWrapper>
        </TierRunOverviewWrapper>
    )
}

export default SllTierRunContent;